import styled from 'styled-components';
import Slide from '../containers/Slide';
import AccentLine from '../widgets/AccentLine';
import GetEducationList from '../../data/education-list';
import { motion, useInView } from "framer-motion"
import React, { useRef } from 'react';
import SectionHeader from '../widgets/SectionHeader';
import AboutImg from '../../res/images/about-img.png';
import CheckmarkIcon from '../../res/icons/checkmark.svg';
import GetNavigationList from '../../data/navigation-list';
import { Link, animateScroll as scroll } from 'react-scroll';
import { globalStore } from '../../AppManager';
import Logo from '../../res/images/logo.png';

const Container = styled.div.attrs({ className: "footer-slide" })`
    width: 75%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
 
    #footer-container {
        width: 100%;
        display: flex;
        justify-content: flex-start;  
        align-items: center;   

        .footer-column {
            width: 33.3%;
            height: 12rem;
            display: flex;
            justify-content: center;  
            align-items: center;   
            flex-shrink: 0;
        }

        .nav-item {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            width: 8rem;
            height: 8rem;

            h6 {
                color: var(--black);
            }

            &:hover {
                background: var(--white);
            }

            &:hover h6 {
                color: var(--yellow);
            }

            &:hover img {
                border-color: var(--black);
            }
        }

        #logo-container {
            width: 300px;
            align-self: stretch;
            background-image: url(${Logo});
            background-size: 75%;
            background-position: center;
            background-repeat: no-repeat;
        }
    }

    @media screen and (max-width: 1200px) {
        width: 100%;
        box-sizing: border-box;
        padding: 0 2rem 0rem 2rem;

        #footer-container {
            flex-direction: column;

            .footer-column {
                width: 100%;
                height: 8rem;
            }
        }
    }
`

export default function FooterSlide() {

    const { visible, setVisible } = globalStore((state) => state.navigation);
    
    return (
        <Slide color="linear-gradient(180deg, transparent, rgba(14, 134, 204, .06));" height="auto" freeHeightBreakpoint="980px">

            <Container>

                <div id='footer-container'>

                    <div id='left-footer-container' className='footer-column'>

                        <Link
                            activeClass='active'
                            containerId='app-content'
                            spy={true}
                            smooth={true}
                            duration={1000}
                            className='nav-item'
                            onClick={() => {
                                scroll.scrollTo(0, { containerId: 'app-content', duration: 1000, delay: 300 }); setVisible(false)
                            }
                            }>

                            <h6> Home </h6>

                        </Link>

                        {
                            GetNavigationList().map((item) =>
                                <Link
                                    activeClass='active'
                                    containerId='app-content'
                                    to={item.to}
                                    spy={true}
                                    smooth={true}
                                    duration={1000}
                                    delay={300}
                                    className='nav-item'
                                    onClick={() => setVisible(false)}>

                                    <h6> {item.text} </h6>

                                </Link>
                            )
                        }

                    </div>

                    <div id='center-footer-container' className='footer-column'>

                        <div id='logo-container'>

                        </div>

                    </div>

                    <div id='right-footer-container' className='footer-column'>

                        © 2026 Flooring Covering Services LLC

                    </div>

                </div>

            </Container>

        </Slide>
    )
}